export default function LoadingSpinner() {
  return (
    <div
      className="spinner-container"
      style={{
        position: "absolute",
        width: "100svw",
        height: "100svh",
        top: "0%",
        left: "0%",
        backgroundColor: "rgba(0,9,5,0.8)",
        zIndex: "1000",
        display: "grid",
        placeItems: "center",
      }}
    >
      <div className="loading-spinner"></div>
    </div>
  );
}
